import { distributionRegionApi } from "@/main/api";
import { SearchFilterRegionRequest } from "@/main/models/request";
import { DistributionRegionResponse } from "@/main/models/response";
import * as StylesShared from "@/main/components/shared/styles";
import * as S from "./styles";
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import { getTranslateByKey } from "@/main/services/utils";
import RowGridRegion from "@/main/screens/registration/region/gridRegionScreen/rowGridRegion/rowGridRegion";
import KOGModalConfirm from "@/main/components/shared/KogmodalConfirm/modalConfirm";
import { useState } from "react";
import { isNullUndefined } from "@/main/services/reducerUtils";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";

function fetchDataRegion(request: any) {
	return distributionRegionApi.searchGrid(request).then((response) => response.data);
}

interface IGridRegionScreenProps {
	datagrid: DistributionRegionResponse[];
	formFilters: SearchFilterRegionRequest | null;
	setDataGrid: React.Dispatch<React.SetStateAction<DistributionRegionResponse[]>>;
	setFormFilters: React.Dispatch<React.SetStateAction<SearchFilterRegionRequest | null>>;
}

function GridRegionScreen({ datagrid, formFilters, setDataGrid, setFormFilters }: Readonly<IGridRegionScreenProps>) {
	const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
	const [region, setRegion] = useState<DistributionRegionResponse | null>(null);

	const rowHeaders = [
		getTranslateByKey("information.regionName"),
		getTranslateByKey("information.initialZipCode"),
		getTranslateByKey("information.finalZipCode"),
		<StylesShared.RowHeaderTextCenter key="actions-header">
			{getTranslateByKey("information.actions")}
		</StylesShared.RowHeaderTextCenter>,
	];

	function onCloseModal() {
		setIsOpenModal(false);
		setRegion(null);
	}

	function onConfirmModal() {
		if (isNullUndefined(region)) {
			return;
		}

		distributionRegionApi.delete(region.guid).then(() => {
			setRegion(null);
			setDataGrid([]);

			if (isNullUndefined(formFilters)) {
				return;
			}

			const request: SearchFilterRegionRequest = {
				...formFilters,
				pageIndex: PaginationEnum.PageIndexIntial,
				pageSize: PaginationEnum.PageSize30,
			};
			setFormFilters(request);
		});
	}

	function updateRowDataGrid(row: DistributionRegionResponse) {
		const index = datagrid.findIndex((item) => item.guid === row.guid);
		if (index === -1) return;

		datagrid[index] = {
			...datagrid[index],
			guidCountry: row.guidCountry ?? datagrid[index].guidCountry,
			countryName: row.countryName ?? datagrid[index].countryName,
			name: row.name,
			zipCodeStart: row.zipCodeStart,
			zipCodeEnd: row.zipCodeEnd,
			active: row.active,
		};

		setDataGrid([...datagrid]);
	}

	return (
		<S.Container>
			<KOGPaginationGrid
				showTitleResults
				dataGrid={datagrid}
				formFilters={formFilters}
				setDataGrid={setDataGrid}
				fetchMore={fetchDataRegion}
				fetchEqualFilters={true}
			>
				<BoxGrid rowHeaders={rowHeaders}>
					{datagrid.map((item, index) => (
						<RowGridRegion
							key={item.guid}
							region={item}
							index={index}
							updateRowDataGrid={updateRowDataGrid}
							setRegion={setRegion}
							setIsModalOpen={setIsOpenModal}
						/>
					))}
				</BoxGrid>
			</KOGPaginationGrid>
			<KOGModalConfirm
				titleModal={getTranslateByKey("information.confirmDeleteRegion").replace("{regionName}", String(region?.name))}
				isOpenModal={isOpenModal}
				setIsOpenModal={setIsOpenModal}
				closeModal={onCloseModal}
				onCancel={onCloseModal}
				onConfirm={onConfirmModal}
			/>
		</S.Container>
	);
}

export default GridRegionScreen;
